import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { IndustrySector } from '../../core/brand/industry-sector.enum';
import { enumValidator } from '../../core/form/enum.validator';

export function industrySectorValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validateEnum = enumValidator(IndustrySector);
    const result = validateEnum(control);
    return result === null ? null : { industrySector: true };
  };
}
